import React, { useEffect } from 'react';
import MainHeading from '../Common/MainHeading';
import animationFunction from '../Common/animationFunction';
import { useLocale } from '../../localization/LocaleContext';


const benefitsData = [
    {
        id:0,
        key:'onlinePayments',
        imgURL:"/images/Group 80.png",
        statKey: 'onlinePaymentsStat',
    },
    {
        id:1,
        key:'signInvoice',
        imgURL:"/images/Group 81.png",
        statKey: 'signInvoiceStat',
    },
    {
        id:2,
        key:'paymentMethod',
        imgURL:"/images/Group 82.png",
        statKey: 'paymentMethodStat',
    },
]
const secondBenefits = [
    {
        id:0,
        key:'estimates',
        imgURL:"/images/Group 83.png",
        statKey: 'estimatesStat',
    },
    {
        id:1,
        key:'timeTracking',
        imgURL:"/images/Group 84.png",
        statKey: 'timeTrackingStat',
    },
]

export default function Benefits(){
    const { t } = useLocale();

    useEffect(() => {
        animationFunction('benefit-box')
    }, [])

    return(
        <section className="Benefits sp-90">
            <MainHeading headingName={t('shared.benefitsTitle')} />
            {/* <h1 className="h-1 h-bold fs-50 mb-20 text-center">
                Benefits of using Invoice Point
            </h1> */}
            <div className="container spt-60">
                <div className="row">
                    {benefitsData.map((i => (
                        <div className="col-lg-4" key={i.id}>
                            <div className="p-30-40 flex-center-align flex-column benefit-box br-5 mb-30">
                                <img src={i.imgURL} className="mb-10" alt="img" />
                                <span className="benefit-stat-badge">{t(`benefits.${i.statKey}`)}</span>
                                <h3 className="h-3 fw-600 mb-10">
                                    {t(`benefits.${i.key}.name`)}
                                </h3>
                                <p className="paragraph p-adjustment">
                                    {t(`benefits.${i.key}.description`)}
                                </p>
                            </div>
                        </div>
                    )))}
                    {secondBenefits.map((i => (
                        <div className="col-lg-6" key={i.id}>
                            <div className="p-30-40 flex-center-align flex-column benefit-box br-5 mb-30">
                                <img src={i.imgURL} className="mb-10" alt="img" />
                                <span className="benefit-stat-badge">{t(`benefits.${i.statKey}`)}</span>
                                <h3 className="h-3 fw-600 mb-10">
                                    {t(`benefits.${i.key}.name`)}
                                </h3>
                                <p className="paragraph p-adjustment">
                                    {t(`benefits.${i.key}.description`)}
                                </p>
                            </div>
                        </div>
                    )))}
                </div>
            </div>
        </section>
    )
}